import { useEffect, useState } from 'react';

/** Iniciales para cuando no hay foto. */
const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('') || '?';

/** Versión de la foto por persona en esta pestaña (para ver al momento la que se acaba de subir). */
const versions = new Map<string, number>();
const listeners = new Set<() => void>();
export function bumpPhoto(personId: string): void {
  versions.set(personId, Date.now());
  listeners.forEach((l) => l());
}

/** Foto de perfil redonda; si no hay, las iniciales. */
export function Avatar({ personId, name, size = 40 }: { personId: string; name: string; size?: number }) {
  const [, force] = useState(0);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const l = () => {
      setFailed(false);
      force((n) => n + 1);
    };
    listeners.add(l);
    return () => void listeners.delete(l);
  }, []);
  useEffect(() => setFailed(false), [personId]);
  const v = versions.get(personId);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };
  if (failed) {
    return (
      <span className="avatar avatar--initials" style={style} aria-hidden="true">
        {initials(name)}
      </span>
    );
  }
  return <img className="avatar" style={style} src={`/api/identity/people/${personId}/photo${v ? `?v=${v}` : ''}`} alt="" loading="lazy" onError={() => setFailed(true)} />;
}
